<template>
  <div>
    <div
      v-if="route != 'multiCriteresListe'"
      class="d-flex justify-center recherche"
      :class="classePipes"
      style="font-size: 13.5px"
      data-testid="searchText"
    >
      Votre recherche : {{ recherche }}
    </div>
    <div
      v-else
      class="d-flex justify-center recherche"
      :class="classePipes"
      style="font-size: 13.5px"
      data-testid="searchText"
    >
      <v-container>
        <v-row>
          <v-col align="center"> Votre recherche multi-critères </v-col>
        </v-row>
        <v-row class="mt-0 pt-0">
          <v-col align="center" class="pt-0">
            <span
              v-for="(crit, index) in Object.keys($store.state.recherche.texte)"
              :key="crit"
            >
              <span v-if="index > 0">+ </span>
              {{
                criteresPossibles != null
                  ? criteresPossibles.find((item) => item.code == crit).intitule
                  : ""
              }}:
              <span
                v-for="(val, index) in $store.state.recherche.texte[crit]"
                :key="val.id"
              >
                <span v-if="index > 0">, </span>
                {{ val.libelle }}
              </span>
            </span>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="d-flex justify-center mb-4" style="font-size: 10.8px">
      <span
        v-if="
          route == 'home' ||
          route == 'denos-communes' ||
          route == 'deno-commune' ||
          route == 'produits-deno-commune' ||
          route == 'fournisseurs-deno-commune'
        "
      >
        <span
          v-if="
            route != 'deno-commune' &&
            route != 'produits-deno-commune' &&
            route != 'fournisseurs-deno-commune'
          "
          class="p-2 rechercheDenos"
          data-testid="nb-denos"
          >{{ denos }}
          dénomination(s) commune(s)
          <span :class="classePipes" class="mx-2">|</span>
        </span>
        <span
          v-if="
            route != 'denos-communes-fournisseur' &&
            route != 'produits-deno-commune'
          "
          class="rechercheFournisseurs"
          data-testid="nb-fournisseurs"
          >{{ fournisseurs }}
          fournisseur(s)
          <span :class="classePipes" class="mx-2">|</span>
        </span>
        <span class="rechercheProduits" data-testid="nb-produits">
          {{ produits }} produit(s)
          <span
            v-if="route == 'produits-deno-commune'"
            :class="classePipes"
            class="mx-2"
            >|</span
          >
        </span>
        <span
          v-if="route == 'produits-deno-commune'"
          class="rechercheFournisseurs"
          data-testid="nb-fournisseurs"
          >{{ fournisseurs }}
          fournisseur(s)
        </span>
      </span>
      <span
        v-else-if="
          route == 'fournisseurs' ||
          route == 'fournisseur' ||
          route == 'produits-fournisseur' ||
          route == 'denos-communes-fournisseur'
        "
      >
        <span v-if="route == 'fournisseurs'">
          <span class="rechercheFournisseurs" data-testid="nb-fournisseurs"
            >{{ fournisseurs }}
            fournisseur(s)
          </span>
          <span :class="classePipes" class="mx-2">|</span>
        </span>
        <span v-if="route != 'produits-fournisseur'">
          <span class="p-2 rechercheDenos" data-testid="nb-denos"
            >{{ denos }} dénomination(s) commune(s) </span
          ><span :class="classePipes" class="mx-2">|</span>
        </span>
        <span class="rechercheProduits" data-testid="nb-produits">
          {{ produits }} produit(s)
        </span>
        <span v-if="route == 'produits-fournisseur'">
          <span :class="classePipes" class="mx-2">|</span>
          <span class="p-2 rechercheDenos" data-testid="nb-denos"
            >{{ denos }} dénomination(s) commune(s)
          </span>
        </span>
      </span>
      <span v-else-if="route == 'produits'">
        <span class="rechercheProduits" data-testid="nb-produits">
          {{ produits }} produit(s)
        </span>
        <span :class="classePipes" class="mx-2">|</span>
        <span class="p-2 rechercheDenos" data-testid="nb-denos"
          >{{ denos }} dénomination(s) commune(s)
        </span>
        <span :class="classePipes" class="mx-2">|</span>
        <span class="rechercheFournisseurs" data-testid="nb-fournisseurs"
          >{{ fournisseurs }}
          fournisseur(s)
        </span>
      </span>
      <span v-else-if="route == 'multiCriteresListe'">
        <span class="rechercheProduits" data-testid="nb-produits">
          {{ produits }} produit(s)
        </span>
        <span :class="classePipes" class="mx-2">|</span>
        <span class="rechercheFournisseurs" data-testid="nb-fournisseurs"
          >{{ fournisseurs }}
          fournisseur(s)
        </span>
        <span :class="classePipes" class="mx-2">|</span>
        <span class="p-2 rechercheDenos" data-testid="nb-denos"
          >{{ denos }} dénomination(s) commune(s)
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "SearchResults",
  computed: {
    ...mapState({
      recherche: (state) => state.recherche.texte,
      type: (state) => state.recherche.type,
      denos: (state) => state.recherche.resultats.nbDenos,
      fournisseurs: (state) => state.recherche.resultats.nbFrns,
      produits: (state) => state.recherche.resultats.nbPdts,
    }),
    criteresPossibles() {
      return this.$route.params.criteresPossibles || this.recherche;
    },
    classePipes() {
      const route = this.route;
      if (
        route == "home" ||
        route == "denos-communes" ||
        route == "deno-commune" ||
        route == "produits-deno-commune" ||
        route == "fournisseurs-deno-commune"
      ) {
        return "rechercheDenos";
      } else if (
        route == "fournisseurs" ||
        route == "fournisseur" ||
        route == "produits-fournisseur" ||
        route == "denos-communes-fournisseur"
      ) {
        return "rechercheFournisseurs";
      } else if (route == "produits" || route == "produit") {
        return "rechercheProduits";
      } else if (route == "multiCriteresListe") {
        return "rechercheMc";
      }

      return "";
    },
    route() {
      return this.$route.name;
    },
  },
};
</script>

<style scoped>
.recherche {
  font-weight: bold;
}

.rechercheDenos {
  color: #325a76;
}

.rechercheFournisseurs {
  color: #cd8d03;
}

.rechercheProduits {
  color: var(--v-produit-darken1);
}

.rechercheMc {
  color: #fb8b67;
}
</style>
